import React from 'react';
import { Box, Typography } from '@mui/material';
import SurgeryDashboardTab from '../components/SurgeryDashboardTab';

export default function SurgeryDashboardPage() {
  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Dashboard de Cirugía
      </Typography>
      <SurgeryDashboardTab />
    </Box>
  );
}
